"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const i18n_js_1 = __importDefault(require("i18n-js"));
const Close_1 = __importDefault(require("@mui/icons-material/Close"));
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const material_1 = require("@mui/material");
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const Chat_1 = __importDefault(require("@mui/icons-material/Chat"));
const ContactSupportOutlined_1 = __importDefault(require("@mui/icons-material/ContactSupportOutlined"));
const TaskOutlined_1 = __importDefault(require("@mui/icons-material/TaskOutlined"));
const ReportOutlined_1 = __importDefault(require("@mui/icons-material/ReportOutlined"));
const Info_1 = __importDefault(require("@mui/icons-material/Info"));
const NotificationPermissions_1 = __importDefault(require("../../Notifications/NotificationPermissions"));
const withStore_1 = __importDefault(require("../../../../common/decorators/withStore"));
const helpers_1 = require("../../../../common/helpers/helpers");
const ChatIntroWrapper = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 16px;
  overflow: auto;

  .chat-icon {
    width: 60px;
    height: 60px;
    margin-bottom: 16px;
  }

  h5 {
    margin-bottom: 6px;
  }

  .center-text {
    width: 80%;
    text-align: center;

    @media (max-width: 1000px) {
      width: 100%;
    }
  }

  .icon-and-text {
    display: flex;
    margin: 20px 0;

    svg {
      margin-right: 8px;
    }
  }

  .disclaimer {
    margin: 10px 0 40px 0;
  }

  .get-started-btn {
    width: 40%;

    @media (max-width: 600px) {
      width: auto;
    }
  }

  .permission-controls {
    /* margin-bottom: 20px; */
    width: 80%;

    @media (max-width: 1000px) {
      width: 100%;
    }
  }

  .settings-link {
    color: ${props => props.theme.palette.primary.main};
  }

  .ios-info-section {
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: center;

    .info-icon {
      margin-right: 6px;
      height: 20px;
      width: 20px;
    }
  }
`;
const LinkPadding = styled_components_1.default.div `
  padding: 10px 0;
`;
const ChatIntroModal = ({ onClose, onAccept, navigations, pushNotificationsEnabled, baseUrl, appData }) => {
    const chatItem = navigations.homePage.find(navigation => navigation.type === 'chat');
    const [permissionWasDenied, setPermissionsWasDenied] = (0, react_1.useState)(false);
    const isTuiBrand = helpers_1.Helpers.isTuiBrand(appData.brandSlug);
    const showIOSInfo = !!(isTuiBrand && helpers_1.Helpers.isMobile.iOS());
    if (isTuiBrand && (('Notification' in window && Notification.permission === 'denied') || permissionWasDenied)) {
        return (react_1.default.createElement(ChatIntroWrapper, null,
            react_1.default.createElement(IconButton_1.default, { "aria-label": "close", className: "collapse-btn", onClick: () => {
                    onClose();
                }, sx: {
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    zIndex: '2',
                    backgroundColor: '#fff',
                    opacity: '0.75',
                } },
                react_1.default.createElement(Close_1.default, null)),
            react_1.default.createElement("div", { className: "icon-wrapper" }, chatItem && chatItem.icon ? (react_1.default.createElement("img", { className: "chat-icon", src: chatItem.icon, alt: "chat-icon" })) : (react_1.default.createElement(Chat_1.default, { className: "chat-icon" }))),
            react_1.default.createElement(Typography_1.default, { variant: "h5", className: "center-text" }, i18n_js_1.default.t('introducing_chat_header_message_center')),
            react_1.default.createElement(Typography_1.default, { variant: "body1", className: "notification-info" },
                react_1.default.createElement("a", { href: "https://help.hotel-mssngr.com/en/articles/8965701-how-to-activate-push-notifications", target: "_blank", rel: "noreferrer", className: "notification-info-link" }, i18n_js_1.default.t('learn_more_about_notifications_how_to_enable_notifications')))));
    }
    return (react_1.default.createElement(ChatIntroWrapper, null,
        !pushNotificationsEnabled && isTuiBrand && (react_1.default.createElement(IconButton_1.default, { "aria-label": "close", className: "collapse-btn", onClick: () => {
                onClose();
            }, sx: {
                position: 'absolute',
                right: 8,
                top: 8,
                zIndex: '2',
                backgroundColor: '#fff',
                opacity: '0.75',
            } },
            react_1.default.createElement(Close_1.default, null))),
        react_1.default.createElement("div", { className: "icon-wrapper" }, chatItem && chatItem.icon ? (react_1.default.createElement("img", { className: "chat-icon", src: chatItem.icon, alt: "chat-icon" })) : (react_1.default.createElement(Chat_1.default, { className: "chat-icon" }))),
        react_1.default.createElement(Typography_1.default, { variant: "h5", className: "center-text" }, i18n_js_1.default.t('introducing_chat_header_message_center')),
        react_1.default.createElement(Typography_1.default, { variant: "body1", className: "center-text" }, i18n_js_1.default.t('introducing_chat_body_message_center')),
        react_1.default.createElement("div", { className: "centered-segment" },
            react_1.default.createElement("div", { className: "icon-and-text" },
                react_1.default.createElement(ContactSupportOutlined_1.default, null),
                react_1.default.createElement(Typography_1.default, { variant: "body1" }, i18n_js_1.default.t('introducing_chat_point_one_message_center'))),
            react_1.default.createElement("div", { className: "icon-and-text" },
                react_1.default.createElement(TaskOutlined_1.default, null),
                react_1.default.createElement(Typography_1.default, { variant: "body1" }, i18n_js_1.default.t('introducing_chat_point_two_message_center'))),
            react_1.default.createElement("div", { className: "icon-and-text" },
                react_1.default.createElement(ReportOutlined_1.default, null),
                react_1.default.createElement(Typography_1.default, { variant: "body1" }, i18n_js_1.default.t('introducing_chat_point_three_message_center')))),
        react_1.default.createElement(Typography_1.default, { variant: "caption", className: "center-text disclaimer" }, i18n_js_1.default.t('chat_deletion')),
        isTuiBrand && !helpers_1.Helpers.isMobile.iOS() && (react_1.default.createElement(NotificationPermissions_1.default, { ignoreLocalStorage: true, onDeny: () => {
                setPermissionsWasDenied(true);
            } })),
        isTuiBrand && ('Notification' in window && !(Notification.permission === 'granted')) && (react_1.default.createElement(LinkPadding, null,
            react_1.default.createElement(Typography_1.default, { variant: "body1", className: "notification-info" },
                react_1.default.createElement("a", { href: "https://help.hotel-mssngr.com/en/articles/8965701-how-to-activate-push-notifications", target: "_blank", rel: "noreferrer", className: "notification-info-link" }, i18n_js_1.default.t('learn_more_about_notifications_how_to_enable_notifications'))))),
        react_1.default.createElement(material_1.Button, { className: "get-started-btn", variant: "contained", size: "large", role: "button", disabled: !pushNotificationsEnabled && isTuiBrand && !helpers_1.Helpers.isMobile.iOS(), onClick: () => {
                onClose();
                onAccept();
            } }, i18n_js_1.default.t('get_started')),
        showIOSInfo && (react_1.default.createElement("div", { className: "ios-info-section center-text" },
            react_1.default.createElement(Info_1.default, { className: "info-icon" }),
            react_1.default.createElement(Typography_1.default, { variant: "body2", className: "" }, i18n_js_1.default.t('tui_webapp_chat_no_notifications'))))));
};
const mapStoreToProps = store => ({
    navigations: store.getValue('navigations'),
    pushNotificationsEnabled: store.getValue('pushNotificationsEnabled'),
    baseUrl: store.getValue('baseUrl'),
    appData: store.getValue('appData'),
});
exports.default = (0, withStore_1.default)(mapStoreToProps)(ChatIntroModal);
